import { collectInvalidSchemaFieldTypeErrors } from './collect-invalid-schema-field-type-errors.js'
import { getSlotAreaFields } from './get-slot-area-fields.js'
import { isSchemaSlotLayout } from './is-schema-slot-layout.js'

export function collectInvalidSchemaSlotFieldTypeErrors(slot: unknown, errors: string[]): void {
  if (!isSchemaSlotLayout(slot)) return
  collectInvalidSchemaFieldTypeErrors(getSlotAreaFields(slot.main), errors)
  collectInvalidSchemaFieldTypeErrors(getSlotAreaFields(slot.sidebar), errors)
}
